const mode = process.env.NODE_ENV;

export const appConfig = {
  api: {
    server: ({
      development: 'http://127.0.0.1:4010'
    })[mode],
  }
}

export default appConfig;